import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'capsule', 'Capsule', [["path",{"d":"M6 9a6 6 0 0 1 6 -6a6 6 0 0 1 6 6v6a6 6 0 0 1 -6 6a6 6 0 0 1 -6 -6l0 -6","key":"svg-0"}]]);